import React, { useEffect, useState } from 'react'
import api from '../../services/ApiService';
import {Form, FormText, Image } from 'react-bootstrap';
import {Modal, ModalContent, ModalHeader, ModalBody, Button, Input, Link} from "@nextui-org/react";
import './ButtonLogin.styles.css';
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import iconGoogle from '../../assets/icons/icons-google.png';
import {EyeFilledIcon} from "./EyeFilledIcon";
import {EyeSlashFilledIcon} from "./EyeSlashFilledIcon";
import { useTranslation } from 'react-i18next';
import { useUser } from '../../contexts/UserContext';

const Register = ({handleChangeForm, handleClose}) => {
  const { authCorrect } = useUser();
  const [ userGoogle, setUserGoogle ] = useState([]);
  const [ errors, setErrors ] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { t } = useTranslation();

  const loginGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUserGoogle(codeResponse)
    },
    onError: (error) => console.log('Login Failed:', error)
  });
  
  useEffect(() => {
    if (userGoogle && userGoogle.access_token != undefined) {
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${userGoogle.access_token}`, {
          headers: {
            Authorization: `Bearer ${userGoogle.access_token}`,
            Accept: 'application/json'
          }})
          .then(async (res) => {
            try {
              const response = await api.users.authGoogle(res.data);
              
              handleClose();
              
              if (response.status == 201 || response.status == 200){
                const {token,user} = response.data;
                authCorrect(user,token);
              }

              if (response.status == 400) {
                const newErrors = {};
                newErrors.register = error.response.data.error;
                setErrors(newErrors);
              }

            } catch (error) {
              if (error.response && error.response.data) {
                const newErrors = {};
                newErrors.register = error.response.data.error;
                setErrors(newErrors);
              }
            }
          })
          .catch((error) =>  {
            if (error.response && error.response.data) {
              const newErrors = {};
              newErrors.register = error.response.data.error;
              setErrors(newErrors);
            }
          });
    }
  },[ userGoogle ]);

  const handleRegisterFormSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    try {
      if (validateForm(formData)){
        
          const response = await api.users.register({
            username: formData.get('username'),
            email: formData.get('email'),
            password: formData.get('password'),
          });
          
          handleClose();
  
          if (response.status == 201){
            const {token,user} = response.data;
            authCorrect(user,token);
          }
      
    }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      if (error.response && error.response.data) {
        const newErrors = {};
        newErrors.register = error.response.data.error;
        setErrors(newErrors);
      }
    }
  };

  const validateForm = (formData) => {
    let valid = true;
    const newErrors = {};
    
    if (formData.get('password').length < 8) {
      newErrors.password = t('auth.passwordValidacion');
      valid = false;
    }
  
    setErrors(newErrors);
    return valid;
  };

  return (
    <Modal 
      isOpen={true}
      onOpenChange={handleClose}
      placement='center'
      >
      <ModalContent>
          <ModalHeader className='flex flex-col gap-3'>{t('auth.registro')}</ModalHeader>
          <ModalBody>
            <Button radius="full" color="primary" variant="ghost" size='lg'  className="form-btn" onClick={loginGoogle}>
              <Image src={iconGoogle} className="google-icon" roundedCircle />{' '}
                {t('auth.registroGoogle')}
            </Button>
            
            <hr/>

            <Form onSubmit={handleRegisterFormSubmit} className='form'>
              <Input 
                radius="full" 
                variant="bordered" 
                label={t('auth.username')} 
                placeholder={t('auth.usernamePlaceholder')}
                type="text"
                name="username"
                id="username"
                autocomplete="username"
                required
              />

              <Input 
                radius="full" 
                variant="bordered" 
                label={t('auth.email')}
                placeholder={t('auth.emailPlaceholder')}
                type="email"
                name='email' 
                id="email"
                autocomplete="email"
                required />

              <Input
                radius="full"
                variant="bordered"
                label={t('auth.password')}
                placeholder={t('auth.passwordPlaceholder')}
                name="password"
                id="password"
                autocomplete="current-password"
                endContent={
                  <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
                    {isVisible ? (
                      <EyeSlashFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                    ) : (
                      <EyeFilledIcon className="text-2xl text-default-400 pointer-events-none" />
                    )}
                  </button>
                }
                type={isVisible ? "text" : "password"}
                required
              />
              {errors.password && <FormText className="text-danger">{errors.password}</FormText>}
              {errors.register && <FormText className="text-danger">{errors.register}</FormText>}

              <div className='buttons-container'>
                <Button radius="full" color="primary" size='lg' type='submit' className="form-btn">
                {t('auth.registrate')}
                </Button>
                
                <p className='sig-up-label'>
                {t('auth.loginPregunta')}
                  <Link color="primary" onClick={handleChangeForm}>
                  {t('auth.iniciaSesion')}
                  </Link>
                </p>
              </div>
            </Form>
          </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default Register